export const BREADCRUMB_SESSION_KEY = "breadcrumbs";
export const BREADCRUMB_MENU_SESSION_KEY = "menuid";

export type IBreadCrumb = {
  label: string;
  id: string | null;
  parentId?: string | null;
};
